import './GetPremiumCTA.scss';

import { ReactComponent as CrownIcon } from '../../images/icons/Crown.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const GetPremiumCTA = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirectToCertificates = () => navigate('/Certifications');

  return (
    <div className='cta-boxes'>
      <div className='cta-header'>
        <div className='cta-title-row'>
          <div className='cta-icon'>
            <CrownIcon />
          </div>
          <span className='cta-title'>{t('GetFullAccessWithPremium', { ns: 'purchaseMembership' })}</span>
        </div>
        <p className='cta-description'>{t('FiftyPercentOffCertificates', { ns: 'purchaseMembership' })}</p>
      </div>
      <button className='cta-button' onClick={redirectToCertificates}>
        {t('StartSubscription', { ns: 'purchaseMembership' })}
      </button>
    </div>
  );
};
